import React from 'react';

const Missouri = () => {
  return (
    <div>
      
    </div>
  );
}

export default Missouri;
